module.exports = __webpack_public_path__ + "img/logo-webtroc_274x85.8cdb6bef.png";